module.exports = __webpack_public_path__ + "media/images/icon_btn_spaces_white-7ce83c17f0455536ccd6249beb2d81b1.svg";